// removed by extract-text-webpack-plugin
module.exports = {"listblob":"_3bCBG7RZ6PJM9Shq8mrnGu","arrow":"Hsj-ViB2KdhoV2spvM5qZ"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/listblob/listblob.scss
// module id = 422
// module chunks = 0